import React, { memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CButton } from '@coreui/react-pro';

import { tryParseJSON } from '../../../utils';
import { COURSE_DIRECT_PATH, GUEST_PATH, LOCAL_ORG_USER } from '../../../constants';
import images from '../../../assets/images';

const PageBack = ({
     path = '',
     title = 'BACK TO HOME',
     titleLearning = 'Back to Learning',
     image = images.arrowBackIcon,
     className = '',
     onClick,
}) => {
     const user = useSelector((state) => state.subscriber.user);
     const email = user?.email;
     const activeOrganizationOwner = tryParseJSON(localStorage.getItem(LOCAL_ORG_USER));
     const infoAccount = activeOrganizationOwner?.organization?.name || email;
     const currentLocation = useLocation().pathname;

     const checkCart = GUEST_PATH.CART;
     const checkCheckout = GUEST_PATH.CHECKOUT;
     const checkPayment = GUEST_PATH.PAYMENT_SUCCESS;
     const checkProduct = GUEST_PATH.SELLING_GROUPS;
     const checkCoupon = GUEST_PATH.CART.substring(0, checkCart.length - 1);
     const localPath = localStorage.getItem(COURSE_DIRECT_PATH);
     const localPathSeats = localPath?.substring(localPath.length, localPath.length - 6);
     const checkLocation =
          currentLocation !== checkCart &&
          currentLocation !== checkCheckout &&
          currentLocation !== checkPayment &&
          currentLocation !== checkProduct &&
          currentLocation !== checkCoupon;

     const handleGoToNextStep = () => {
          window.history.go(-1);
     };

     const handleGoToNextStepOrg = () => {
          window.history.go(-2);
     };

     return (
          <div className={`page-back ${className}`}>
               {path && email && title !== 'BACK' && checkLocation && localPathSeats !== 'seats/' && localPath !== null ? (
                    <CButton className="text-underline" onClick={handleGoToNextStep} color="link">
                         <img src={image} alt="back icon" />
                         {titleLearning}
                    </CButton>
               ) : path && email && title !== 'BACK' && checkLocation && localPathSeats === 'seats/' && localPath !== null ? (
                    <CButton className="text-underline" onClick={handleGoToNextStepOrg} color="link">
                         <img src={image} alt="back icon" />
                         {titleLearning}
                    </CButton>
               ) : path && infoAccount !== email && title === 'Back to Home' ? (
                    <Link to={{ pathname: '/my-organization/' }}>
                         <img src={image} alt="back icon" />
                         {title}
                    </Link>
               ) : path && title === 'BACK TO CART' ? (
                    <Link to={GUEST_PATH.CART}>
                         <img src={image} alt="back icon" />
                         {title}
                    </Link>
               ) : path && infoAccount === email ? (
                    <Link to={path}>
                         <img src={image} alt="back icon" />
                         {title}
                    </Link>
               ) : (
                    <CButton onClick={onClick} color="link">
                         <img src={image} alt="back icon" />
                         {title}
                    </CButton>
               )}
          </div>
     );
};

export default memo(PageBack);
